import { roundButton as e } from "../styled/Composer.styled.mjs";
import { styled as t } from "styled-components";
//#region src/components/Composer/components/ComposerAction.styled.ts
var n = t.button`
    ${e};
    background: transparent;
    color: ${({ theme: e }) => e.colors.mutedForeground};
    transition:
        color ${({ theme: e }) => e.transitions.fast},
        transform ${({ theme: e }) => e.transitions.fast};

    &:hover:not(:disabled) {
        color: ${({ theme: e }) => e.colors.foreground};
    }
    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
`;
//#endregion
export { n as ActionButton };
